import { useState, useEffect } from 'react';

export function useReducedMotion(): boolean {
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    setPrefersReducedMotion(mediaQuery.matches);

    const handleChange = (event: MediaQueryListEvent) => {
      setPrefersReducedMotion(event.matches);
    };

    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  return prefersReducedMotion;
}

export function useAnimationConfig() {
  const reducedMotion = useReducedMotion();

  return {
    duration: reducedMotion ? 0 : 0.6,
    staggerDelay: reducedMotion ? 0 : 0.1,
    spring: reducedMotion 
      ? { type: 'tween', duration: 0 } 
      : { type: 'spring', stiffness: 100, damping: 15 },
    fadeInUp: reducedMotion
      ? { opacity: 1, y: 0 }
      : { opacity: 0, y: 30 },
    scaleIn: reducedMotion
      ? { opacity: 1, scale: 1 }
      : { opacity: 0, scale: 0.95 },
  };
}
